import "./Card.css";

export enum CardType {
  question = "m-question",
  answer = "m-answer",
}

export enum WordType {
  singular = "m-singular",
  plural = "m-plural",
}

type CardProps =
  | {
      type: CardType.question;
      word: WordType.singular;
      children: { __html: string };
    }
  | {
      type: CardType.answer;
      word: WordType.plural;
      children: { __html: string };
    };

export const Card = (props: CardProps) => {
  switch (props.type) {
    case CardType.question:
      return (
        <div className={`Card__container ${props.type}`}>
          <div className={`Card ${props.type}`}>
            <div className={`Card__handle ${props.type}`}></div>
            <p className="Card__permaQuestion">
              What's the <span className="Card__actual">actual</span> plural for{" "}
              <div
                className="Card__singular"
                dangerouslySetInnerHTML={props.children}
              ></div>
            </p>
          </div>
        </div>
      );
    case CardType.answer:
      return (
        <div className={`Card__container ${props.type}`}>
          <div className={`Card ${props.type}`}>
            <div className={`Card__handle ${props.type}`}></div>
            <p
              className="Card__plural"
              dangerouslySetInnerHTML={props.children}
            ></p>
          </div>
        </div>
      );
  }
};
